import { render, staticRenderFns } from "./CompaignBudget.vue?vue&type=template&id=2154ae39&scoped=true&"
import script from "./CompaignBudget.vue?vue&type=script&lang=js&"
export * from "./CompaignBudget.vue?vue&type=script&lang=js&"
import style0 from "./CompaignBudget.vue?vue&type=style&index=0&id=2154ae39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154ae39",
  null
  
)

export default component.exports